import React, { useRef, useEffect} from 'react';
import classes from './Footer.module.scss';
import globalJson from 'data/content.json';

const Footer = (props) => {

    return(
        <footer className={classes.Footer}>
            <div className={`container`}>
                    <p className={classes.Footer__title}>{globalJson.footer.text}<a className={classes.Footer__link} href={globalJson.footer.link} target="_blank" rel="noopener noreferrer"> Read more</a></p>
            </div>
        </footer>
    )
}

export default Footer;